import { render, staticRenderFns } from "./CollectionManagement.vue?vue&type=template&id=44e1e988&scoped=true&"
import script from "./CollectionManagement.vue?vue&type=script&lang=js&"
export * from "./CollectionManagement.vue?vue&type=script&lang=js&"
import style0 from "./CollectionManagement.vue?vue&type=style&index=0&id=44e1e988&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44e1e988",
  null
  
)

export default component.exports